import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'

import Icon from '../../Shared/Icon/Icon'

import ProjectsForm from './ProjectsForm'

function ProjectsFormModal({ onModalClose }) {
  return (
    <Modal
      isOpen
      shouldCloseOnOverlayClick
      onRequestClose={onModalClose}
      contentLabel="Modal"
      ariaHideApp={false}
      className={{
        base: '',
        afterOpen: 'overlay-modal--container_after-open overlay-modal-container',
        beforeClose: 'overlay-modal--container_before-close',
      }}
      overlayClassName={{
        base: 'overlay-modal--background',
        afterOpen: 'overlay-modal--background_after-open',
        beforeClose: 'overlay-modal--background_before-close',
      }}
    >
      <div className="overlay-modal">
        <button className="btn btn-transparent overlay-modal--close-inner" onClick={onModalClose}>
          <Icon type={['far', 'times']} color="grey-dark" />
        </button>
        <div className="overlay-modal--content">
          <ProjectsForm isModal />
        </div>
      </div>
    </Modal>
  )
}

ProjectsFormModal.propTypes = {
  onModalClose: PropTypes.func.isRequired,
}

export default ProjectsFormModal
